// extracted by mini-css-extract-plugin
module.exports = {"tabsContainer":"Segments_tabsContainer__35Ck-","tab":"Segments_tab__1FYIJ","tabActive":"Segments_tabActive__1PyqG","userCounter":"Segments_userCounter__2t5vt"};